<div class="container">
    <h2 class="my-5">Travel Packages for The Honeymooner</h2>

    <section class="col-md-10">

        <div class="card mt-3">
            <div class="card-content row">
                <div class="col-md-3">
                    <img src="../../../assets/images/elementor-placeholder-image.webp" class="w-100 rounded-2 rounded-end-0">
                </div>
                <div class="col-md-7 p-3">
                    <h4>Vacation Package #1</h4>
                    <h6>Lorem ipsum dolor sit amet, consectetur adipiscing elit. Nullam vitae consectetur nunc.</h6>

                    <div><strong>Valid Travel Dates:</strong> Apr 1 &mdash; Jul 31</div>
                    <div>Includes flight, hotel, spa, breakfast</div>
                </div>
                <div class="col-md-2">
                    <h4 class="text-primary text-end mt-3 me-3">from $8192</h4>
                    <h5 class="text-end me-3">7 Nights</h5>

                    <a href="javascript:void(0)" class="btn btn-outline-primary">Book Now</a>
                </div>
            </div>

        </div>
        <div class="card mt-3">
            <div class="card-content row">
                <div class="col-md-3">
                    <img src="../../../assets/images/elementor-placeholder-image.webp" class="w-100 rounded-2 rounded-end-0">
                </div>
                <div class="col-md-7 p-3">
                    <h4>Vacation Package #2</h4>
                    <h6>Lorem ipsum dolor sit amet, consectetur adipiscing elit. Nullam vitae consectetur nunc.</h6>

                    <div><strong>Valid Travel Dates:</strong> Apr 1 &mdash; Jul 31</div>
                    <div>Includes flight, hotel, tours, breakfast &amp; dinner</div>
                </div>
                <div class="col-md-2">
                    <h4 class="text-primary text-end mt-3 me-3">from $4096</h4>
                    <h5 class="text-end me-3">5 Nights</h5>

                    <a href="javascript:void(0)" class="btn btn-outline-primary">Book Now</a>
                </div>
            </div>

        </div>
        <div class="card mt-3">
            <div class="card-content row">
                <div class="col-md-3">
                    <img src="../../../assets/images/elementor-placeholder-image.webp" class="w-100 rounded-2 rounded-end-0">
                </div>
                <div class="col-md-7 p-3">
                    <h4>Vacation Package #3</h4>
                    <h6>Lorem ipsum dolor sit amet, consectetur adipiscing elit. Nullam vitae consectetur nunc.</h6>

                    <div><strong>Valid Travel Dates:</strong> Apr 1 &mdash; Jul 31</div>
                    <div>Includes flight, bed and breakfast, tours, transporation, breakfast</div>
                </div>
                <div class="col-md-2">
                    <h4 class="text-primary text-end mt-3 me-3">from $4096</h4>
                    <h5 class="text-end me-3">3 Nights</h5>

                    <a href="javascript:void(0)" class="btn btn-outline-primary">Book Now</a>
                </div>
            </div>

        </div>
    </section>
</div>
